<template>
    <div class="animated fadeIn">
        <b-list-group class="list-group-accent mx-2 flex-fill" style="min-height: 500px;">
            <b-list-group-item href="#"
                class="list-group-item-divider text-center d-flex align-items-center justify-content-between"
                :class="isToday ? 'list-group-item-accent-primary' : 'list-group-item-accent-secondary'"
                :aria-label="'Adicionar agendamento em ' + item.weekday + ' ' + item.date"
                @click="openAddModal"
                >
                <b-badge pill variant="secondary" class="day-badge">
                    {{ item.date.slice(-2) }}
                </b-badge>
                <span>
                    &nbsp; {{ item.weekday }}
                    <b-badge v-if="isToday" variant="primary" class="ml-1">Hoje</b-badge>
                </span>
                <div class="flex-grow-1 d-flex justify-content-center">

                </div>
                <span class="add-badge" title="Novo agendamento"><i class="fa fa-plus"></i></span>
            </b-list-group-item>


            <b-list-group-item href="#"
                class="list-group-item-divider"
                :class="meeting.variant"
                v-for="meeting in item.meetings.filter(m => m.st == 1)" :key="meeting.id"
                @click="openEditModal(meeting)"
            >
                <div class="d-flex justify-content-between">
                    <span>{{ meeting.startTime }}</span>
                    <span>{{ meeting.endTime }}</span>
                </div>
                <span class="check-badge bg-info text-white">
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M13.485 4.485a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414 0l-2.121-2.121a1 1 0 1 1 1.414-1.414l1.414 1.414 4.95-4.95a1 1 0 0 1 1.414 0z"/>
                    </svg>
            </span>

                <b>{{ meeting.name }}</b>
                <br>
                {{ meeting.description }}<br>
            </b-list-group-item>
        </b-list-group>

          <b-modal
              v-model="agendaDateAddModal"
              id="agenda-date-add-modal"
              centered
              hide-footer
              title="Novo Agendamento"
              size="lg">

             <b-form>
                <b-button variant="github" class="mr-1 btn-brand" @click="changeCombinedRoom" size="lg" v-if="meetingRooms"><i :class="roomClass"></i><span>{{ roomLabel }}</span></b-button>
                <hr>
                <b-form-group label="Data" label-for="meeting-date">
                <b-form-datepicker
                    id="meeting-date"
                    v-model="startDate"
                    :value="item.date"
                    :date-format="'yyyy-MM-dd'"
                    class="w-100"
                ></b-form-datepicker>
                </b-form-group>

                <b-form-group label="Horário">
                    <div class="d-flex">
                        <div class="flex-fill mr-2">
                        <label for="meeting-start-time" class="small">Início</label>
                        <b-form-input
                            id="meeting-start-time"
                            v-model="startTime"
                            type="time"
                            step="900"
                            class="w-100"
                        ></b-form-input>
                        <!--
                        <b-form-timepicker
                            id="meeting-start-time"
                            v-model="startTime"
                            :minute-step="15"
                            class="w-100"
                        ></b-form-timepicker>
                        -->
                        </div>
                        <div class="flex-fill ml-2">
                        <label for="meeting-end-time" class="small">Término</label>
                        <b-form-input
                            id="meeting-end-time"
                            v-model="endTime"
                            type="time"
                            step="900"
                            class="w-100"
                        ></b-form-input>
                        <!--
                        <b-form-timepicker
                            id="meeting-end-time"
                            v-model="endTime"
                            :minute-step="15"
                            class="w-100"
                        ></b-form-timepicker>
                        -->
                        </div>
                    </div>
                </b-form-group>

                <b-form-group label="Nome da Reunião" label-for="meeting-name">
                <b-form-input
                    id="meeting-name"
                    v-model="meetingName"
                    placeholder="Digite o nome da reunião"
                ></b-form-input>
                </b-form-group>

                <b-form-group label="Descrição" label-for="meeting-description">
                <b-form-textarea
                    id="meeting-description"
                    v-model="meetingDescription"
                    placeholder="Digite a descrição"
                    rows="4"
                ></b-form-textarea>
                </b-form-group>

                <b-form-group label="Prioridade" label-for="meeting-color">
                  <b-form-select
                    id="meeting-color"
                    v-model="meetingColor"
                    :options="colorOptions"
                    class="w-100"
                  >
                    <template #option="{ option }">
                      <span style="display:inline-flex;align-items:center;">
                        <span class="priority-swatch border-secondary"></span>
                        <span>{{ option.text }}</span>
                      </span>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-form>

            <div class="d-flex justify-content-end mt-4">
                <b-button variant="github" class="mr-1 btn-brand" @click="addMeeting"><i class="fa fa-check"></i><span>Adicionar</span></b-button>
            </div>

          </b-modal>

          <b-modal
              v-model="agendaDateEditModal"
              id="agenda-date-edit-modal"
              centered
              hide-footer
              :title="`Editar Agendamento ${meetingRoomAdm && meetingRoomAdm==1 ? ' (Administrador)' : ''}`"
              size="lg">

             <b-form>
                <b-form-group label="Data" label-for="meeting-date">
                <b-form-datepicker
                    id="meeting-date"
                    v-model="startDate"
                    :value="item.date"
                    :date-format="'yyyy-MM-dd'"
                    class="w-100"
                    disabled
                ></b-form-datepicker>
                </b-form-group>

                <b-form-group label="Horário">
                    <div class="d-flex">
                        <div class="flex-fill mr-2">
                        <label for="meeting-start-time" class="small">Início</label>
                        <b-form-input
                            id="meeting-start-time"
                            v-model="startTime"
                            type="time"
                            step="900"
                            class="w-100"
                            disabled
                        ></b-form-input>
                        <!--
                        <b-form-timepicker
                            id="meeting-start-time"
                            v-model="startTime"
                            :minute-step="15"
                            class="w-100"
                        ></b-form-timepicker>
                        -->
                        </div>
                        <div class="flex-fill ml-2">
                        <label for="meeting-end-time" class="small">Término</label>
                        <b-form-input
                            id="meeting-end-time"
                            v-model="endTime"
                            type="time"
                            step="900"
                            class="w-100"
                            disabled
                        ></b-form-input>
                        <!--
                        <b-form-timepicker
                            id="meeting-end-time"
                            v-model="endTime"
                            :minute-step="15"
                            class="w-100"
                        ></b-form-timepicker>
                        -->
                        </div>
                    </div>
                </b-form-group>

                <b-form-group label="Nome da Reunião" label-for="meeting-name">
                <b-form-input
                    id="meeting-name"
                    v-model="meetingName"
                    placeholder="Digite o nome da reunião"
                ></b-form-input>
                </b-form-group>

                <b-form-group label="Descrição" label-for="meeting-description">
                <b-form-textarea
                    id="meeting-description"
                    v-model="meetingDescription"
                    placeholder="Digite a descrição"
                    rows="4"
                ></b-form-textarea>
                </b-form-group>

                <b-form-group label="Prioridade" label-for="meeting-color">
                  <b-form-select
                    id="meeting-color"
                    v-model="meetingColor"
                    :options="colorOptions"
                    class="w-100"
                  >
                    <template #option="{ option }">
                      <span style="display:inline-flex;align-items:center;">
                        <span class="priority-swatch border-secondary"></span>
                        <span>{{ option.text }}</span>
                      </span>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-form>

            <div class="d-flex justify-content-end mt-4">                
                <b-button variant="youtube" class="mr-1 btn-brand" @click="deleteMeeting" v-show="(meetingRoomAdm && meetingRoomAdm==1) || (selectedMeeting && selectedMeeting.uid == $store.state.currentUser.id)"><i class="fa fa-trash"></i><span>{{ deleteConfirm ? 'Confirmar Exclusão' : 'Excluir' }}</span></b-button>
                <b-button variant="github" class="mr-1 btn-brand" @click="addMeeting" v-show="(meetingRoomAdm && meetingRoomAdm==1) || (selectedMeeting && selectedMeeting.uid == $store.state.currentUser.id)"><i class="fa fa-check"></i><span>Alterar Agendamento</span></b-button>
            </div>

         </b-modal>
         
    </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";
import { BForm, BFormGroup, BFormInput, BFormTextarea, BFormDatepicker, BFormTimepicker, BButton } from 'bootstrap-vue'

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */


export default {
    name: 'AgendaDateComponent',
    components: {
        BForm, BFormGroup, BFormInput, BFormTextarea, BFormDatepicker, BFormTimepicker, BButton
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        meetingRooms: {
            type: Array,
            required: false
        },
        meetingRoomAdm: {
            type: Number,
            required: false
        },
        isToday: {
            type: Boolean,
            default: false
        },
    },
    data: function() {
        return {
            deleteConfirm: false,
            combinedRoom: false,
            roomLabel: '',
            roomClass: 'fa fa-user',
            agendaDateAddModal: false,
            agendaDateEditModal: false,            
            startDate: this.item.date,
            startTime: '',
            endTime: '',
            meetingName: '',
            meetingDescription: '',
            meetingColor: '',
            colorOptions: [
                { text: 'Normal', value: 1 },
                { text: 'Baixa', value: 3 },
                { text: 'Alta', value: 7 }
            ],
            selectedMeeting: null
        }
    },
    watch: {
        startTime(newVal) {
            if (!this.endTime || this.endTime < newVal) {
                if (newVal && newVal.length === 5) {
                    let [h, m] = newVal.split(':').map(Number);
                    h = (h + 1) % 24;
                    this.endTime = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
                }
            }
        },
        combinedRoom() {
            var _this = this;
            if(this.combinedRoom) {
                this.roomLabel = this.combinedRoomLabel();
                this.roomClass = 'fa fa-group';
            }
            else {
                var foundRoom = this.meetingRooms.find(function(room) {
                  return room.id === _this.item.meetingRoomId;
                });
                this.roomLabel = foundRoom ? foundRoom.name : '';
                this.roomClass = 'fa fa-user';
            }
        }
    },
    methods: {
        deleteMeeting() {
            if(!this.deleteConfirm) {
                miniToastr.warn("Clique novamente para confirmar a exclusão.", "Atenção");
                this.deleteConfirm = true; // Set to true to wait for confirmation
                return;
            }
            else {
                var s = this;
                var currentUser = this.$store.state.currentUser;
                if (!currentUser || !currentUser.id) {
                    miniToastr.error("Sessão não carregada. Recarregue a página e tente novamente.", "Erro");
                    return;
                }
                axios.get(this.$store.state.ws_url + '/meetingroom/reservation/delete?meetingRoomId=' + this.selectedMeeting.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid)
                .then(resp => {                    
                    if(resp.data.code > 0) {
                        miniToastr.success("Reunião excluída com sucesso!", "Sucesso");
                        s.$emit('meetingResponse', null); // Emit an event to notify parent component
                        s.agendaDateEditModal = false;
                    }
                    else {
                        miniToastr.warn(resp.data.message, "Aviso");
                    } 
                })
                .catch(error => {
                    miniToastr.error("Erro ao agendar reunião: " + error.message, "Erro");
                });
                
            }
        },
        combinedRoomLabel() {
            if (!Array.isArray(this.meetingRooms)) return '';
            var currentRoom = this.meetingRooms.find(room => room.id === this.item.meetingRoomId);
            if (!currentRoom || !currentRoom.groupId) {
                return currentRoom ? currentRoom.name : '';
            }
            return this.meetingRooms
                .filter(function(room) { return room.groupId === currentRoom.groupId; })
                .map(function(room) { return room.name; })
                .join(' + ');
        },
        changeCombinedRoom() {
            this.combinedRoom = !this.combinedRoom;            
        },
        combineDateTime(dateStr, timeStr) {
            if (!dateStr || !timeStr) return '';
            return dateStr.length <= 10 ? dateStr + 'T' + timeStr + ':00-03:00' : dateStr;
        },
        openAddModal() {        
            this.selectedMeeting = null; // Reset selected meeting

            this.startDate = this.item.date;
            this.startTime = '08:00';
            this.endTime = '09:00';
            this.meetingName = this.$store.state.currentUser.name;
            this.meetingDescription = '';
            this.agendaDateAddModal = true;
            this.meetingColor = 1; // Default color
        },
        openEditModal(meeting) {
            this.selectedMeeting = meeting;

            this.startDate = this.selectedMeeting.startDate;
            this.startTime = this.selectedMeeting.startTime;
            this.endTime = this.selectedMeeting.endTime;
            this.meetingName = this.selectedMeeting.name;
            this.meetingDescription = this.selectedMeeting.description;
            this.meetingColor = this.selectedMeeting.variantId || 1; // Default to 1 if not set
            if(this.meetingColor == 6)
                this.meetingColor = 1; // Reset to default if color is 6
            this.agendaDateEditModal = true;
            this.deleteConfirm = false; // Reset delete confirmation state
        },
        addMeeting() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            if (!currentUser || !currentUser.id) {
                miniToastr.error("Sessão não carregada. Recarregue a página e tente novamente.", "Erro");
                return;
            }
            // Compose startDate and endDate as ISO strings with selected date and time
            var meeting = {
                id: this.selectedMeeting ? this.selectedMeeting.id : null, // New meeting, so id is 0
                meetingRoomId: this.item.meetingRoomId,
                startDate: this.combineDateTime(this.startDate, this.startTime),
                endDate: this.combineDateTime(this.startDate, this.endTime),
                name: this.meetingName,
                description: this.meetingDescription,
                variantId: this.meetingColor,
                combinedRoom: this.combinedRoom ? 1 : 0,
                uid: currentUser.id,
                sid: currentUser.sid
            };

            axios.post(this.$store.state.ws_url + '/meetingroom/reservation', meeting)
                .then(resp => {                    
                    if(resp.data.code > 0) {
                        miniToastr.success("Reunião agendada/alterada com sucesso!", "Sucesso");
                        s.$emit('meetingResponse', resp.data.obj); // Emit an event to notify parent component
                        s.agendaDateAddModal = false;
                        s.agendaDateEditModal = false;
                    }
                    else {
                        miniToastr.warn(resp.data.message, "Aviso");
                    } 
                })
                .catch(error => {
                    miniToastr.error("Erro ao agendar reunião: " + error.message, "Erro");
                });
            
        }

    },
    mounted() {
        // Set initial roomLabel based on combinedRoom state, avoid optional chaining
        var _this = this;
        if(this.combinedRoom) {
            this.roomLabel = this.combinedRoomLabel();
            this.roomClass = 'fa fa-group';
        }
        else {
            var foundRoom = this.meetingRooms.find(function(room) {
              return room.id === _this.item.meetingRoomId;
            });
            this.roomLabel = foundRoom ? foundRoom.name : '';
            this.roomClass = 'fa fa-user';
        }
    }
}
</script>

<style scoped>
.day-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: 1rem;
}
.add-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
}
.check-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 10px;
}
.priority-swatch {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 8px;
    border-width: 1px;
    border-style: solid;
}
</style>

